module.exports = __webpack_public_path__ + "img/firm.8faaf22c.svg";